<template>
    <section>
        <el-select class="select-vpc"
            v-model="keypairId"
            clearable
            @visible-change="getRealTimePublicKey"
            :placeholder="$t('listPage.placeholder.choose')"
            :no-data-text="$t('speechCraft.listNoText')">
            <el-option v-for="(key, index) in keyShowList"
                :key="index"
                :label="key.name"
                :value="key.keypairId">
            </el-option>
        </el-select>
        <el-tooltip class="ml10" effect="dark" placement="right">
            <div slot="content" class="my-os-disk-tip">
                <p>{{$t('privateNetInstance.sosSecretKeyTipPart1')}}</p>
                <p>{{$t('privateNetInstance.sosSecretKeyTipPart2')}}</p>
            </div>
            <a><i class="jc-icon-question"></i></a>
        </el-tooltip>
    </section>
</template>

<script>
export default {
    name: 'SosSecretKey',
    model: {
        prop: 'selectKey',
        event: 'changeSelectKey'
    },
    props: {
        region: {
            type: String,
            default: ''
        },
        selectKey: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            keypairId: '',
            keyShowList: []
        };
    },
    computed: {
    },
    watch: {
        keypairId(val) {
            this.$emit('changeSelectKey',val);
        }
    },
    created() {
    },
    methods: {
        getRealTimePublicKey(visible) {
            if (visible) {
                this.getPublicKey();
            }
        },
        getPublicKey() {
            const params = {
                region: this.region,
                pageSize: 200
            };
            Ajax.get('/api/cps/listKeypairs', params)
            .then((res) => {
                this.keyShowList = res.data.keypairs.map(key => {
                    return {
                        keypairId: key.keypairId,
                        name: key.name,
                        publicKey: key.publicKey                       
                    }
                });
            })
            .catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            });
        },
    },
};
</script>

<style lang="sass">
    @import "./style"
</style>



// WEBPACK FOOTER //
// src/components/common/sosSecretKey/SosSecretKey.vue